import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // Site
    title: null,
    propertyId: null,
    subpropertyId: null,
    // User
    language: localStorage.getItem('language') || 'en',
    currentUser: null,
    userHasIdDocument: false,
    // Layout
    visibleProgramsType: null,
    visibleProgramsAmount: null,
    // Modals config
    dialogWidth: '750px',
    lockDialog: false,
    applyFlowSuccessCallback: null,
    dialogOnCloseCallback: null,
    // Modals
    loginModalVisible: false,
    signupModalVisible: false,
    forgotPasswordModalVisible: false,
    betweenStepsModalVisible: false,
    inscriptionDeleteModalVisible: false,
    inscriptionDeleteModalCallback: false,
    successModalVisible: false,
    successModalType: undefined,
  },
  getters: {
    // Site
    title: state => state.title,
    propertyId: state => state.propertyId,
    subpropertyId: state => state.subpropertyId,
    // User
    language: state => state.language,
    currentUser: state => state.currentUser,
    userHasIdDocument: state => state.userHasIdDocument,
    // Layout
    visibleProgramsType: state => state.visibleProgramsType,
    visibleProgramsAmount: state => state.visibleProgramsAmount,
    // Modals config
    dialogWidth: state => state.dialogWidth,
    lockDialog: state => state.lockDialog,
    applyFlowSuccessCallback: state => state.applyFlowSuccessCallback,
    dialogOnCloseCallback: state => state.dialogOnCloseCallback,
    // Modals
    loginModalVisible: state => state.loginModalVisible,
    signupModalVisible: state => state.signupModalVisible,
    forgotPasswordModalVisible: state => state.forgotPasswordModalVisible,
    betweenStepsModalVisible: state => state.betweenStepsModalVisible,
    inscriptionDeleteModalVisible: state => state.inscriptionDeleteModalVisible,
    inscriptionDeleteModalCallback: state => state.inscriptionDeleteModalCallback,
    successModalVisible: state => state.successModalVisible,
    successModalType: state => state.successModalType,
  },
  mutations: {
    // Site
    setTitle(state, payload) {
      state.title = payload
    },
    setPropertyId(state, payload) {
      state.propertyId = payload
    },
    setSubpropertyId(state, payload) {
      state.subpropertyId = payload
    },
    // User
    setLanguage(state, { language }) {
      state.language = language
    },
    setCurrentUser(state, payload) {
      if (!payload) state.currentUser = null
      else state.currentUser = payload
    },
    setUserHasIdDocument(state, payload) {
      state.userHasIdDocument = payload
    },
    // Layout
    setVisibleProgramsType(state, { type }) {
      if (!type) state.visibleProgramsType = null
      state.visibleProgramsType = type
    },
    setVisibleProgramsAmount(state, { amount }) {
      state.visibleProgramsAmount = amount
    },
    // Modals config
    setDialogWidth(state, payload) {
      state.dialogWidth = payload
    },
    setLockDialog(state, payload) {
      state.lockDialog = payload
    },
    setApplyFlowSuccessCallback(state, payload) {
      state.applyFlowSuccessCallback = payload
    },
    setDialogOnCloseCallback(state, payload) {
      state.dialogOnCloseCallback = payload
    },
    // Modals
    setLoginModalVisible(state, payload) {
      state.loginModalVisible = payload
    },
    setSignupModalVisible(state, payload) {
      state.signupModalVisible = payload
    },
    setForgotPasswordModalVisible(state, payload) {
      state.forgotPasswordModalVisible = payload
    },
    setBetweenStepsModalVisible(state, payload) {
      state.betweenStepsModalVisible = payload
    },
    setInscriptionDeleteModalVisible(state, payload) {
      state.inscriptionDeleteModalVisible = payload
    },
    setInscriptionDeleteModalCallback(state, callback) {
      state.inscriptionDeleteModalCallback = callback
    },
    setSuccessModalVisible(state, payload) {
      state.successModalVisible = payload
    },
    setSuccessModalType(state, payload) {
      state.successModalType = payload
    },
  },
  actions: {
    // Only async logic
  }
})

export default store
